import { gsap, ScrollTrigger } from 'gsap/all'
gsap.registerPlugin(ScrollTrigger)

export function imageMask(
  imageParent: HTMLElement,
  scrolltriggerAttributes?: { trigger?: HTMLElement; start?: string; end?: string; markers?: boolean }
) {
  const { trigger, start, end, markers } = scrolltriggerAttributes || {}
  const parentSection = imageParent.closest('section')
  const imageMask = imageParent.querySelector('.js-mask')
  // query selector image
  const image = imageParent.querySelector('img.js-img')

  gsap.set(imageParent, { yPercent: 101 })
  gsap.set(image, { scale: 1.5 })
  gsap.set(imageMask, { yPercent: -101 })

  const anim = gsap
    .timeline({
      scrollTrigger: {
        trigger: parentSection,
        start: start || 'center bottom',
        end: end || 'bottom bottom',
        invalidateOnRefresh: true,
        markers: markers || false
      },
      defaults: {
        ease: 'expo.out'
      }
    })
    .to([imageParent], { yPercent: 0 })
    .to([imageMask], { yPercent: 0 }, 0)
    .to([image], { duration: 1, scale: 1 }, 0)
}
